import React from 'react'

const Button = ({
  children,
  onClick,
  className,
  type = "button",
  title,
  disabled,
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${className}`}
      title={title}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button;
